import New from "csi/table/New";
import declare from "dojo/_base/declare";
import PromoteToShape from "src/ProductSpec/Style/PromoteToShape";


const NewShapeFromStyle = declare([New, PromoteToShape], {
});

export = NewShapeFromStyle;